<modal-dialog dialogId="appSelectorSelectorDialog" #modalDialog [showCloseButton]="true"
  [size]="isMobile ? modalDialog.dialogSize.Small :  modalDialog.dialogSize.Large">
  <loading-overlay [show]="dialogLoading">
    @if (appLinks && appLinks.length == 0) {
      <h1 style="text-align: center;">
        Actualmente no tiene acceso a ningún modulo de esta sección
      </h1>
    }
    <div class="vscroll">
      @for (appLinks of appLinksGrid; track $index) {
        <div class="row">
          @for (appLink of appLinks; track appLink.resourceId) {
            <launcher-app-card
              [appLink]="appLink"
              [isMobile]="isMobile"
              (click)="close()"
              [id]="'appCard-' + appLink.resourceId"
            ></launcher-app-card>
          }
        </div>
      }
    </div>
  </loading-overlay>
</modal-dialog>
